<div class="backgroundLogin"></div>
<div class="loginForm">
    <h2 [innerHtml]="'LOGIN' | translate">Login</h2>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

        <mat-form-field>
            <input matInput [placeholder]="'USERNAME' | translate" formControlName="username" required>
            <mat-error *ngIf="submitted && f.username.errors && f.username.errors.required">{{'USERNAME_REQUIRED'|translate}}
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <input matInput [placeholder]="'PASSWORD' | translate" type="password" formControlName="password" required value="">
            <mat-error *ngIf="submitted && f.password.errors && f.password.errors.required">{{'PASSWORD_REQUIRED'|translate}}
            </mat-error>
        </mat-form-field>
        <div class="loginFormBottom">
            <button [disabled]="loading" class="btn btn-outline-light">
                <app-progressbar *ngIf="loading"></app-progressbar>
                {{'LOGIN' | translate}}
            </button>
            <br/>

            <a class="password-forgot" routerLink="/password-forgot" routerLinkActive="" placement="bottom"
               [ngbTooltip]="'FORGOT_PASSWORD_TOOLTIP' | translate" [innerHtml]="('FORGOT_PASSWORD' | translate) + '?'">Forgot password ?</a>
            <br clear="right"/>
        </div>


    </form>
</div>
